<template>
  <v-dialog v-model="mutableDialog" max-width="290" persistent>
    <v-card>
      <v-card-text class="text-xs-center">
        選択した写真の枚数が少ないので空白のページができますが、よろしいですか?
      </v-card-text>

      <v-card-actions class="justify-center">
        <v-btn color="primary" @click="$emit('ok')">
          OK
        </v-btn>
        <v-btn color="negative" @click="mutableDialog = false">
          キャンセル
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {
    dialog: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    mutableDialog: {
      get() {
        return this.dialog;
      },
      set(val) {
        if (!val) {
          this.$emit("cancel");
        }
      }
    }
  }
};
</script>
